__turbopack_context__.v({
  "accordionContent": "styles-module__n9JJ9a__accordionContent",
  "animatedFadeIn": "styles-module__n9JJ9a__animatedFadeIn",
  "fadeIn": "styles-module__n9JJ9a__fadeIn",
  "fadeOut": "styles-module__n9JJ9a__fadeOut",
  "slideDown": "styles-module__n9JJ9a__slideDown",
  "slideUp": "styles-module__n9JJ9a__slideUp",
});
